export const HIDE_MY_PROFILE_MAX = 30 // Company domain
export const MAX_COMPANY_NAME = 30 // Company name
export const WAIT_TYPING_MILISECONDS = 1000
export const DEFAULT_SUCCESS_CODE = 200
export const UPDATE_TYPE = {
    ADD: 'add',
    REMOVE: 'remove'
}
export const ResumeType = {
    AttachCV: 'attach-cv',
    Profile: 'profile'
}

export enum ChangeSearchableResponseStatus {
    SUCCESS,
    ERROR,
    UNCONTACTABLE
}

export const nationalityList = (langCode: string = 'vi') => {
    const nationalityList = {
        en: [
            { id: 1, name: 'Local Vietnamese' },
            { id: 2, name: 'Foreigner' }
        ],
        vi: [
            { id: 1, name: 'Người Việt Nam' },
            { id: 2, name: 'Người nước ngoài' }
        ]
    }

    return nationalityList[langCode]
}

export const PROFILE_SETTING_OPTIONS = 'VNW_PROFILE_SETTING_OPTIONS'
export const REFRESH_WEEKLY = 2
export const REFRESH_DAILY = 1
export const REFRESH_ON = 1
export const REFRESH_OFF = 0
export const SEARCHABLE_ON = 1
export const SEARCHABLE_OFF = 0
export const ONLINE_CV = 0
export const ATTACH_CV = 1

export const UN_CONTACTABLE_ON = 1
export const API_GET_DOMAIN = '/api-gateway/v1.0/profile/get-user-hidden-domains'
export const API_UPDATE_DOMAIN = '/api-gateway/v1.0/profile/update-user-hidden-domains'
export const API_GET_NAME = '/api-gateway/v1.0/profile/get-user-hidden-companies'
export const API_UPDATE_NAME = '/api-gateway/v1.0/profile/update-user-hidden-companies'
export const API_GET_NAME_UNHIDDEN = '/api-gateway/v1.0/profile/get-user-unhidden-companies'
export const API_CHANGE_SEARCHABLE = '/api-gateway/v1.0/profile/resume-change-searchable'
export const API_GET_RESUME_INFO = '/api-gateway/v2.0/profile/resume-setting-info'
export const API_REFRESH_PROFILE = '/api-gateway/v1.0/profile/refresh-profile'
export const API_LEVEL_PROFILE = '/api-gateway/v1.0/profile/level'
export const API_UPDATE_RESUME_SETTING_OPTION = '/api-gateway/v1.0/profile/cookie'
export const API_GET_RESUME_ATTACHMENT_LIST = '/api-gateway/v1.0/profile/resume-attached'
export const API_GET_OPEN_TO_WORK = '/api-gateway/v1.0/profile/open-to-work'

export const vnwBasePath = process.env.NEXT_PUBLIC_VNW_BASE_URL ?? ''
